import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  yourNewBalanceX: {
    id: 'yourNewBalanceX',
    defaultMessage: 'Your new Tim Card balance is {newBalance}',
    description: 'No description',
  },

  success: {
    id: 'success',
    defaultMessage: 'Success',
    description: 'No description',
  },

  loadXOnTimCard: {
    id: 'loadXOnTimCard',
    defaultMessage: 'Load {amount} on Tim Card',
    description: 'No description',
  },

  selectPaymentMethodToAddFunds: {
    id: 'selectPaymentMethodToAddFunds',
    defaultMessage:
      'Please select the payment method that will be used to add funds to your account.',
    description: 'No description',
  },

  selectPaymentMethod: {
    id: 'selectPaymentMethod',
    defaultMessage: 'Select payment method',
    description: 'No description',
  },

  paymentMethod: {
    id: 'paymentMethod',
    defaultMessage: 'Payment Method',
    description: 'No description',
  },

  letsLoadX: {
    id: 'letsLoadX',
    defaultMessage: "Let's load {amount} to get you started.",
    description: 'No description',
  },

  timCardInstructions: {
    id: 'timCardInstructions',
    defaultMessage: 'You can use your Tim Card to pay for all your purchases online and in-store.',
    description: 'No description',
  },

  emptyStateTimCardHeadline: {
    id: 'emptyStateTimCardHeadline',
    defaultMessage: 'Tim Card',
    description: 'No description',
  },

  welcomeToYour: {
    id: 'welcomeToYour',
    defaultMessage: 'Welcome to Your',
    description: 'No description',
  },

  loadYourTimCard: {
    id: 'loadYourTimCard',
    defaultMessage: 'Load your Tim Card',
    description: 'No description',
  },

  prepaidAccountAlreadyExistsError: {
    id: 'prepaidAccountAlreadyExistsError',
    defaultMessage: 'A new Tim Card could not be created since your account already has a Tim Card',
    description: 'No description',
  },

  chatWithUs: {
    id: 'chatWithUs',
    defaultMessage: 'chat with us',
    description: 'No description',
  },

  addGiftCardError: {
    id: 'addGiftCardError',
    defaultMessage:
      'We were unable to create a digital Tim Card. Your payment method has not been charged. Please try again or {link}.',
    description: 'No description',
  },
});
